import styled from 'styled-components';

export const EventSectionItemStyle = styled.div`
  .select-section-type,
  .select-section-item-list {
    .label {
      margin-right: 15px;
      font-size: 16px;
      font-weight: 600;
      color: #495057;
    }
  }

  .select-section-type {
    margin-bottom: 30px;

    .amondz-select {
      width: 300px;
    }
  }

  .section-navigation-tab {
    display: flex;
    flex-direction: column;
    gap: 15px;
    margin-bottom: 30px;

    .section-mobility-wrap {
      .main-content {
        display: flex;
        height: 40px;
        align-items: center;

        .label {
          width: 180px;
          font-size: 15px;
          font-weight: 500;
          text-align: left;
          color: rgba(0, 0, 0, 0.65);
        }
      }

      .sub-content {
        font-size: 14px;
        color: #6200ea;
        line-height: 20px;
        padding-left: 180px;
      }
    }
  }

  .select-section-item-list {
    margin-top: 30px;
  }
`;
